<script>
import { POINT_MARKER_ICON_CONFIG } from '@/utils/mapSettings';

export default {
  props: {
    google: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
    marker: {
      type: Object,
      required: true,
    },
  },
  computed: {
    infoWindow() {
      const iw = this.marker.infoWindow;
      return `<h6><a href="https://perivolidb.co.uk/schools${this.marker.id}">${iw.schoolName}</a></h6>
      <br>
      <p>Country: ${iw.country}</p>
      <p>Village/Town: ${iw.village}</p>
      `;
    },
  },
  mounted() {
    const { Marker } = this.google.maps;
    const { InfoWindow } = this.google.maps;

    const marker = new Marker({
      position: this.marker.position,
      marker: this.marker,
      map: this.map,
      icon: POINT_MARKER_ICON_CONFIG,
    });

    const infoWindow = new InfoWindow({
      content: this.infoWindow,
    });

    marker.addListener('mouseover', () => {
      infoWindow.open(this.map, marker);
    });

    marker.addListener('mouseout', () => {
      infoWindow.close();
    });
  },

  render() {},
};
</script>

<style scoped>
a:link {
  color: #000000;
}
</style>
